import React from 'react';
import links from '../../../../config/links';

import DescriptionStylable from '../../text/DescriptionStylable';
import BackgroundImage from '../../BackgroundImage';
import CheckboxSA from '../../FormElementsStandalone/CheckboxSA';
import withStatsig from '../../hocs/withStatsig';

class DualMatchHeaderMobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            scoreTeam1: 0,
            scoreTeam2: 0,
            isWinnerTeam1: false,
            isWinnerTeam2: false,
            submitting: false,
        };
        this.handleScoreChange = this.handleScoreChange.bind(this);
        this.handleWinnerChange = this.handleWinnerChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { scoreTeam1, scoreTeam2, isWinnerTeam1, isWinnerTeam2 } = this.props;
        this.setState({
            scoreTeam1,
            scoreTeam2,
            isWinnerTeam1,
            isWinnerTeam2,
            submitting: false,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.scoreTeam1 !== this.state.scoreTeam1 || nextProps.scoreTeam2 !== this.state.scoreTeam2) {
            this.setState((prevState) => ({
                // eslint-disable-next-line react/no-access-state-in-setstate
                ...(nextProps.scoreTeam1 !== prevState.scoreTeam1 ? { scoreTeam1: nextProps.scoreTeam1 } : {}),
                // eslint-disable-next-line react/no-access-state-in-setstate
                ...(nextProps.scoreTeam2 !== prevState.scoreTeam2 ? { scoreTeam2: nextProps.scoreTeam2 } : {}),
            }));
        }

        if (nextProps.isWinnerTeam1 !== this.state.isWinnerTeam1 || nextProps.isWinnerTeam2 !== this.state.isWinnerTeam2) {
            this.setState((prevState) => ({
                // eslint-disable-next-line react/no-access-state-in-setstate
                ...(nextProps.isWinnerTeam1 !== prevState.isWinnerTeam1 ? { isWinnerTeam1: nextProps.isWinnerTeam1 } : {}),
                // eslint-disable-next-line react/no-access-state-in-setstate
                ...(nextProps.isWinnerTeam2 !== prevState.isWinnerTeam2 ? { isWinnerTeam2: nextProps.isWinnerTeam2 } : {}),
            }));
        }
    }

    handleScoreChange(score, team) {
        const newScore = score.slice(-2);
        this.setState({
            [team === 'team1' ? 'scoreTeam1' : 'scoreTeam2']: newScore,
        });
        this.props.handleScoreChange(newScore, this.props[team].clubId);
    }

    async handleWinnerChange(team) {
        const { isWinnerTeam1, isWinnerTeam2 } = this.state;
        const isWinner = team === 'team1' ? !isWinnerTeam1 : !isWinnerTeam2;

        this.setState({
            [team === 'team1' ? 'isWinnerTeam1' : 'isWinnerTeam2']: isWinner,
            [team === 'team1' ? 'isWinnerTeam2' : 'isWinnerTeam1']: false,
            submitting: true,
        });
        await this.props.handleWinnerChange(isWinner, this.props[team].clubId);
        this.setState({ submitting: false });
    }

    render() {
        const {
            isAdmin,
            isUserPowered,
            team1,
            team2,
            scoreTeam1,
            scoreTeam2,
            matchType,
            eventLocations,
            isTeamTennisMatch,
            displayMatchStatus,
            checkGate,
            featureGates,
        } = this.props;

        const isRostersRolloutEnabled = checkGate(featureGates.ROSTERS_ROLLOUT);

        const showIsWinner = isAdmin;

        const getHeaderLabel = () => (isTeamTennisMatch ? 'Team Match' : 'Dual Match');

        return (
            <>
                <div className="mb8 text-highlight3 fs12 text-center">
                    {matchType || getHeaderLabel()}
                </div>
                <div className="d-flex flex-row align-items-center jcsb">
                    <div className="flex-1 d-flex flex-col">
                        <BackgroundImage
                            baseUrl={'/v1/club/'}
                            defaultImage={'/img/utr-ball--teal.svg'}
                            images={team1.clubProfileImages}
                            imageType={'icon'}
                            parentStylesClass={'team-logo mr16 asfe'}
                        />
                        <div className="text-right fs10">
                            <h5
                                className="clickable title-uppercase show-ellipsis mt8 mb0 fs14"
                                onClick={() => this.props.redirectTo(`/${isTeamTennisMatch ? 'clubs' : 'schools'}/${team1.clubId}`)}
                            >
                                {team1.isCollege ? (team1.shortName || team1.displayName || team1.name) : (team1.displayName || team1.name)}
                            </h5>
                            {isRostersRolloutEnabled && !!(isUserPowered && team1.power6) && (
                                <div className="show-ellipsis">{`${team1.power6.toFixed(2)} Power 6`}</div>
                            )}
                            {team1.location?.display && (
                                <div className="show-ellipsis">{team1.location.display}</div>
                            )}
                        </div>
                    </div>
                    <div className={`match-status`}>
                        {!isAdmin && displayMatchStatus && (
                            <div className="flex-1 d-flex flex-row align-items-center justify-content-center">
                                <div className={`team-score-value ml8 ${scoreTeam1 > scoreTeam2 ? 'text-dark' : ''}`}>
                                    {scoreTeam1}
                                </div>
                                <span className={`winner-arrow ml8 ${(scoreTeam1 > scoreTeam2) ? 'text-dark visible' : 'invisible'}`}>{'\u25C0'}</span>
                                <div className="text-center ml8 mr8">
                                    VS
                                </div>
                                <span className={`winner-arrow mr8 ${(scoreTeam2 > scoreTeam1) ? 'text-dark visible' : 'invisible'}`}>{'\u25B6'}</span>
                                <div className={`team-score-value mr8 ${scoreTeam2 > scoreTeam1 ? 'text-dark' : ''}`}>
                                    {scoreTeam2}
                                </div>
                            </div>
                        )}
                        {isAdmin && (
                            <div className="flex-1 d-flex flex-row align-items-center justify-content-center">
                                <div className={`team-score-input d-flex flex-column align-items-center justify-content-center`}>
                                    <input
                                        type="number"
                                        placeholder="0"
                                        min={0}
                                        max={99}
                                        className="form-control dashed"
                                        value={this.state.scoreTeam1 || 0}
                                        onChange={(e) => this.handleScoreChange(e.target.value, 'team1')}
                                    />
                                    {showIsWinner && (
                                        <div className="text-center mt8 team-winner">
                                            <CheckboxSA
                                                checked={this.state.isWinnerTeam1 || false}
                                                onChange={() => this.handleWinnerChange('team1')}
                                                disabled={this.state.submitting}
                                            />
                                            <span className="fs10">Is Winner</span>
                                        </div>
                                    )}
                                </div>
                                <div className="text-center ml16 mr16">
                                    VS
                                </div>
                                <div className={`team-score-input d-flex flex-column align-items-center justify-content-center`}>
                                    <input
                                        type="number"
                                        placeholder="0"
                                        min={0}
                                        max={99}
                                        className="form-control dashed"
                                        value={this.state.scoreTeam2 || 0}
                                        onChange={(e) => this.handleScoreChange(e.target.value, 'team2')}
                                    />
                                    {showIsWinner && (
                                        <div className="text-center mt8 team-winner">
                                            <CheckboxSA
                                                checked={this.state.isWinnerTeam2 || false}
                                                onChange={() => this.handleWinnerChange('team2')}
                                                disabled={this.state.submitting}
                                            />
                                            <span className="fs10">Is Winner</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="flex-1 d-flex flex-col">
                        <BackgroundImage
                            baseUrl={'/v1/club/'}
                            defaultImage={'/img/utr-ball--teal.svg'}
                            images={team2.clubProfileImages}
                            imageType={'icon'}
                            parentStylesClass={'team-logo ml16'}
                        />
                        <div className="fs10">
                            <h5
                                className="clickable title-uppercase show-ellipsis mt8 mb0 fs14"
                                onClick={() => this.props.redirectTo(`/${isTeamTennisMatch ? 'clubs' : 'schools'}/${team2.clubId}`)}
                            >
                                {team2.isCollege ? (team2.shortName || team2.displayName || team2.name) : (team2.displayName || team2.name)}
                            </h5>
                            {isRostersRolloutEnabled && !!(isUserPowered && team2.power6) && (
                                <div className="show-ellipsis">{`${team2.power6.toFixed(2)} Power 6`}</div>
                            )}
                            {team2.location?.display && (
                                <div className="show-ellipsis">{team2.location.display}</div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-row align-items-center jcsb">
                    <div className="flex-1 d-flex flex-col">
                        {isAdmin && team1.rosterHasUnclaimedPlayers && (
                            <div className="error-text fs8 text-left">
                                This team’s roster is incomplete, which might prevent you from entering every match result. The coach must add their missing players and complete their roster using this <a href={links.hsRosterArticle} rel="noopener noreferrer" target="_blank">support guide</a>.
                            </div>
                        )}
                    </div>
                    <div className="flex-1 d-flex flex-col">
                        {isAdmin && team2.rosterHasUnclaimedPlayers && (
                            <div className="error-text fs8 text-left">
                                This team’s roster is incomplete, which might prevent you from entering every match result. The coach must add their missing players and complete their roster using this <a href={links.hsRosterArticle} rel="noopener noreferrer" target="_blank">support guide</a>.
                            </div>
                        )}
                    </div>
                </div>
                <div className="d-flex flex-row jcc mt16">
                    <div className="text-center fs10 show-ellipsis">
                        <DescriptionStylable desc={[eventLocations[0]?.locationDisplay || '']} />
                    </div>
                </div>
            </>
        );
    }
}

export default withStatsig(DualMatchHeaderMobile);
